import config from '../../config';

export default {
  url: `${config.api.baseURL}/modules/:id`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/get.js